export default __webpack_public_path__ + "static/media/icn-download-24px.54a158a8.svg";